/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/RailChains.css';
import Table from '../Table/Table';
import CustomButton from '../CustomElements/CustomButton';
import useUrlNavigate from '../../customHook/useUrlNavigate';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
import CustomContainer from '../CustomElements/CustomContainer';
import AddRailChains from './AddRailChain';
import Modal from '../Modal/Modal';
import Input from '../CustomElements/Input';
import RailChainsTable from './RailChainsTable';
import Selector from '../CustomElements/Selector';
import CustomTitle from '../CustomElements/CustomTitle';
import Preloader from '../CustomElements/Preloader';
import ViewModifiedRailChains from './ViewModifiedRailChains';
import DisplayModifiedTrack from './DisplayModifiedTrack';
import { renderCords, useInfocard, useIsEditing } from './Common';
// Кастомные хуки
import { useRole } from '../../customHook/useRole';
import useVisibleSpans from '../../customHook/useVisibleSpans';
import useSelectableColumns from '../../customHook/useSelectableColumns';
// Утилиты
import { defaultCellRender } from '../../utils/formatValueForHTML';
import { getYandexLinearMap, getYandexPointsLink } from '../../utils/mapUtils';
import { cloneArray } from '../../utils/arrUtils';
import { processTracks } from '../../utils/railChainsTableInputChangeHandlers';
import extractNewValuesById from '../../utils/extractNewValuesById';
// Действия Redux
import {
  getDataCheckResultFromServer,
  getXlsxFileFromServer,
  requestRailChains,
  updateRailChainsFromServer,
  getZipFileFromServer,
} from '../../redux/actions/infocards.action';
import { load, remove } from '../../redux/actions/loader.action';

// Этот компонент отвечает за отображение и редактирование рельсовых цепей

export default function RailChains({ t }) {
  const dispatch = useDispatch();
  // Получение сообщения об ошибке из глобального состояния
  const error = useSelector((state) => state.error);

  //текст для окна подтверждения если при запросе была ошибка текст меняем на другой
  const [confirmText, setConfirmText] = useState(t?.changesSaved || 'Изменения РЦ завершены');

  //если при запросе на изменение ошибка меняем текст в окне
  useEffect(() => {
    if (error.error) {
      setConfirmText(t?.changesNotSaved || 'Изменения РЦ не сохранены!');
    }
  }, [error]);

  // роли пользователя
  const isAdmin = useRole('admin');

  // Получаем данные о процессе
  let loader = useSelector((state) => state.loader);

  // отслеживаем наличие сообщений об ошибках на странице
  const coordErrors = useVisibleSpans();

  // данные об измененных РЦ
  const modifiedRailChains = useRef({});

  // Состояния для отображения компонентов и модального окна
  const [isOpen, setIsOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  //состояние для модального окна подтверждения изменений
  const [confirmationOfChanges, setConfirmationOfChanges] = useState(false);

  // состояние для модалки с сообщением с успешном удалении
  const [successModal, setSuccessModal] = useState(false);

  //состояние для модалки подтверждения удаления
  const [confirmDelete, setConfirmDelete] = useState(false);

  // состояние для отображения кнопки показывающей изменение трека
  const [viewBtnModifyTrack, setViewBtnModifyTrack] = useState(true);

  // функция для проверки наличия поля трек и обновления состояния
  const handleCheckTrackField = (data) => {
    const trackExists = Object.values(data).some((section) => 'track' in section);
    setViewBtnModifyTrack(trackExists);
  };

  const [showDisplayModifiedTrack, setShowDisplayModifiedTrack] = useState(false);

  const { stationId, stationName, kitId } = useInfocard();

  let navigate = useUrlNavigate();
  const { isEditing, setEditing } = useIsEditing();

  // получаем массив РЦ
  const source = useSelector((s) => s.infocards.railChains);

  // создаем копию массива РЦ для редактирования в таблице
  const [copySource, setCopySource] = useState(cloneArray(source));
  // Обновляем copySource при изменении source
  useEffect(() => {
    setCopySource(cloneArray(source));
  }, [source]);

  // Обновляем copySource при открытии таблицы редактирования
  useEffect(() => {
    setCopySource(cloneArray(source));
  }, [isEditing]);

  const [firstUpdateCopySource, setFirstUpdateCopySource] = useState(false);

  //записываем id измененного РЦ чтобы раздизейблить кнопку "сохранить"
  const isUpdate = (id) => {
    if (!firstUpdateCopySource) {
      setFirstUpdateCopySource(true);
      handleModify(id);
    }
  };

  // состояние для хранения id строк в которых ошибки в поле трек
  const [errorIds, setErrorIds] = useState([]);

  // состояние для хранения id строк в которых ошибки в поле трек
  const [errorCoordIds, setErrorCoordIds] = useState(new Set());

  // состояние для хранения id измененных строк
  const [modifiedIds, setModifiedIds] = useState(new Set());

  // Функция для добавления id row, если его еще нет в множестве
  const handleModify = (id) => {
    setModifiedIds((prevIds) => {
      const newIds = new Set(prevIds);
      newIds.add(id);
      return newIds;
    });
  };

  const [search, setSearch] = useState('');
  const searchInputRef = useRef(null);

  const handleDownloadXlsx = (event) => {
    event.preventDefault();
    dispatch(getXlsxFileFromServer(stationId, stationName));
  };

  const handleDownloadZip = (event) => {
    event.preventDefault();
    dispatch(getZipFileFromServer(stationId, kitId));
  };

  const handleDataCheck = (event) => {
    event.preventDefault();
    dispatch(getDataCheckResultFromServer(stationId, stationName));
  };

  const onApply = () => {
    dispatch(load());
    setConfirmationOfChanges(false);
    // собираем в пейлоад только те объекты id которых помечены как измененные
    const payload = extractNewValuesById(modifiedRailChains?.current);
    // проверяем корректность  треков
    const invalidIds = processTracks(payload);
    if (invalidIds) {
      setErrorIds(invalidIds);
      return;
    }
    dispatch(updateRailChainsFromServer(stationId, payload));
  };

  // отслеживаем выполнение запроса
  useEffect(() => {
    if (!loader?.isLoading && loader?.isSuccess && isEditing && !confirmDelete) {
      // очищаем стейт отслеживающий загрузку
      dispatch(remove());
      //очищаем стейт с id  измененных объектов
      setModifiedIds(new Set());
      setConfirmModal(true);
      setIsOpen(true);
      setFirstUpdateCopySource(false);
    }
  }, [loader?.isLoading, loader?.isSuccess]);

  // запрашиваю элементы от сервера
  useEffect(() => {
    if (Number.isFinite(+stationId)) {
      dispatch(requestRailChains(stationId));
    }
  }, [stationId]);

  // при перезагрузке сбрасываем массив id треков с ошибкой
  useEffect(() => {
    setErrorIds([]);
  }, []);

  // колонки таблицы
  const columns = useMemo(() => {
    return [
      {
        Header: t?.railChId || 'ID РЦ',
        accessor: 'id',
        id: 'rail-chain-header',
        width: 'var(--sadr-font-size-150)',
        Cell: ({ cell: { value } }) => <span id="rail-chain-header">{defaultCellRender(value)}</span>,
      },
      {
        Header: t?.alertSectionLength || 'Длина участка оповещения',
        columns: [
          {
            Header: t?.labelPCh || 'ПЧ',
            accessor: 'alertLengthsPCh',
            width: 'var(--sadr-font-size-100)',
            Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
          },
          {
            Header: t?.labelECh || 'ЭЧ',
            accessor: 'alertLengthsECh',
            width: 'var(--sadr-font-size-100)',
            Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
          },
        ],
      },
      {
        Header: t?.object || 'Объект',
        accessor: 'object',
        width: 'var(--sadr-font-size-200)',
        Cell: ({ cell: { value } }) => <span style={{ whiteSpace: 'nowrap' }}>{defaultCellRender(value)}</span>,
      },
      {
        Header: t?.railChain || 'Рельсовая цепь',
        accessor: 'railChainName',
        width: 'var(--sadr-font-size-150)',
        Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
      },
      {
        Header: t?.ordinalsEnd || 'Ординаты концов РЦ',
        columns: [
          {
            Header: t?.ordEndHeader || 'Питающий конец',
            accessor: 'ordEnd',
            width: 'var(--sadr-font-size-120)',
            Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
          },
          {
            Header: () => <div style={{}}>{t?.controlledBranch || 'Контролируемое ответвление'}</div>,
            id: 'controlledBranch',
            columns: [
              {
                Header: t?.controlledOrdAHeader || 'А (релейный конец)',
                accessor: 'controlledOrdA',
                width: 'var(--sadr-font-size-120)',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
              {
                Header: t?.controlledOrdBHeader || 'Б',
                accessor: 'controlledOrdB',
                width: 'var(--sadr-font-size-120)',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
              {
                Header: t?.controlledOrdVHeader || 'В',
                accessor: 'controlledOrdV',
                width: 'var(--sadr-font-size-120)',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
              {
                Header: t?.controlledOrdHeader || 'Г',
                accessor: 'controlledOrdG',
                width: 'var(--sadr-font-size-120)',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
            ],
          },
          {
            Header: () => <div style={{}}>{t?.uncontrolledBranch || 'Неконтролируемое ответвление'}</div>,
            id: 'uncontrolledBranch', // добавлено уникальное значение id
            columns: [
              {
                Header: t?.uncontrolledOrdN1Header || 'H1',
                accessor: 'uncontrolledOrdN1',
                width: 'var(--sadr-font-size-150)',
                minWidth: '200px',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
              {
                Header: t?.uncontrolledOrdN2Header || 'H2',
                accessor: 'uncontrolledOrdN2',
                width: 'var(--sadr-font-size-150)',
                minWidth: '200px',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
              {
                Header: t?.uncontrolledOrdN3Header || 'H3',
                accessor: 'uncontrolledOrdN3',
                width: 'var(--sadr-font-size-150)',
                minWidth: '200px',
                Cell: ({ cell: { value } }) => <span>{defaultCellRender(value)}</span>,
              },
            ],
          },
        ],
      },
      {
        Header: t?.coordinatesEnd || 'Координаты концов РЦ',
        columns: [
          {
            Header: t?.ordEndHeader || 'Питающий конец',
            id: 'coordinateEnd',
            width: 'var(--sadr-font-size-300)',
            Cell: ({ row }) => {
              const lat = row.original.coordinateEndLat;
              const lon = row.original.coordinateEndLon;
              return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
            },
          },
          {
            Header: t?.controlledBranch || 'Контролируемое ответвление',
            columns: [
              {
                Header: t?.controlledOrdAHeader || 'А (релейный конец)',
                id: 'coordinateControlledA',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateControlledLatA;
                  const lon = row.original.coordinateControlledLonA;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
              {
                Header: t?.controlledOrdBHeader || 'Б',
                id: 'coordinateControlledB',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateControlledLatB;
                  const lon = row.original.coordinateControlledLonB;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
              {
                Header: t?.controlledOrdVHeader || 'В',
                id: 'coordinateControlledV',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateControlledLatV;
                  const lon = row.original.coordinateControlledLonV;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
              {
                Header: t?.controlledOrdHeader || 'Г',
                id: 'coordinateControlledG',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateControlledLatG;
                  const lon = row.original.coordinateControlledLonG;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
            ],
          },
          {
            Header: t?.uncontrolledBranch || 'Неконтролируемое ответвление',
            columns: [
              {
                Header: t?.uncontrolledOrdN1Header || 'H1',
                id: 'coordinateUncontrolledN1',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateUncontrolledLatN1;
                  const lon = row.original.coordinateUncontrolledLonN1;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
              {
                Header: t?.uncontrolledOrdN2Header || 'H2',
                id: 'coordinateUncontrolledN2',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateUncontrolledLatN2;
                  const lon = row.original.coordinateUncontrolledLonN2;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
              {
                Header: t?.uncontrolledOrdN3Header || 'H3',
                id: 'coordinateUncontrolledN3',
                width: 'var(--sadr-font-size-300)',
                Cell: ({ row }) => {
                  const lat = row.original.coordinateUncontrolledLatN3;
                  const lon = row.original.coordinateUncontrolledLonN3;
                  return renderCords(getYandexPointsLink)({ cell: { value: { lat, lon } } });
                },
              },
            ],
          },
        ],
      },
      {
        Header: t?.track || 'Трек',
        id: 'track',
        accessor: 'track',
        width: 'var(--sadr-font-size-300)',
        Cell: renderCords(getYandexLinearMap) || '-',
      },
    ];
  }, [source]);

  const { selectOptions, filteredColumns, handleSelectChange, selectValue } = useSelectableColumns(columns);

  const go2root = useCallback(() => {
    navigate((url, root) => {
      url.pathname = root;
    });
    // Удаляем признак "занятости" интерфейса
    dispatch(remove());
  }, [navigate, dispatch]);

  return (
    <div id="railchains-container" className="d-flex flex-column h-100 container-fluid overflow-hidden flex-nowrap">
      {!isEditing && (
        <div className="rail-chains-select-container">
          <Input
            id="input-rail-chains-select-container"
            name={'search-rc'}
            type="search"
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            margin={0}
            defaultValue={search}
            placeholder={t?.searchPlaceholder || 'Поиск по ключевым словам...'}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            _ref={searchInputRef}
          />
          <Selector
            options={selectOptions}
            onChange={(selectedOption) => handleSelectChange(selectedOption)}
            placeholder={t?.columnSelectorPlaceholder || 'Показать/скрыть поля'}
            filtersBlock={true}
            width="100%"
            height="var(--sadr-font-size-60)"
            value={selectValue}
            isMulti={true}
            name="railchains-columns-selector"
            isView
            optionSquare
          />
        </div>
      )}
      {!isEditing && (
        <Table
          data={source}
          columns={filteredColumns}
          className="flex-grow-1 rail-chains-table"
          searchInput={search}
          fixFirstColumn={true}
          filterWithoutBtn={true}
        />
      )}
      {isEditing && (
        <RailChainsTable
          stationId={stationId}
          handleModify={handleModify}
          source={source}
          setCopySource={setCopySource}
          copySource={copySource}
          errorIds={errorIds}
          setErrorIds={setErrorIds}
          errorCoordIds={errorCoordIds}
          setErrorCoordIds={setErrorCoordIds}
          isUpdate={isUpdate}
          successModal={successModal}
          setSuccessModal={setSuccessModal}
          confirmDelete={confirmDelete}
          setConfirmDelete={setConfirmDelete}
          modifiedRailChains={modifiedRailChains?.current}
          t={t}
        />
      )}

      <div className={`d-flex flex-row flex-nowrap ${isAdmin ? 'justify-content-evenly' : 'justify-content-center'}`}>
        {!isEditing && (
          <>
            {isAdmin && (
              <>
                <CustomButton
                  className="confirmation-btn"
                  text={`+ ${t?.addRailChain}` || '+ Добавить РЦ'}
                  onClick={() =>
                    navigate((u, root) => {
                      u.pathname = root + '/create';
                    })
                  }
                  isButton
                />
                <CustomButton
                  className="confirmation-btn"
                  text={t?.edit || 'Редактировать'}
                  onClick={() => setEditing(true)}
                  isButton
                  disabled={source?.length < 1}
                />
              </>
            )}
            <CustomButton
              className="confirmation-btn"
              text={t?.export || 'Выгрузить'}
              onClick={handleDownloadXlsx}
              isButton
            />
            <CustomButton
              className="confirmation-btn"
              text={t?.exportZip || 'Выгрузить zip'}
              onClick={handleDownloadZip}
              isButton
            />
            <CustomButton
              className="confirmation-btn"
              text={t?.runChecks || 'Выполнить проверки'}
              onClick={handleDataCheck}
              isButton
            />
          </>
        )}
        {isEditing && (
          <>
            <CustomButton
              className="confirmation-btn"
              text={t?.save || 'Сохранить'}
              onClick={() => {
                setIsOpen(true);
                setConfirmationOfChanges(true);
                setConfirmModal(true);
                handleCheckTrackField(modifiedRailChains?.current);
              }}
              disabled={modifiedIds.size === 0 || errorIds?.length > 0 || errorCoordIds.size > 0 || coordErrors}
              isButton
            />
            <CustomButton
              className="confirmation-btn cancel"
              color="var(--sadr-background-secondary)"
              colorText="var(--sadr-border)"
              text={t?.cancel || 'Отмена'}
              onClick={() => {
                setIsOpen(false);
                setModifiedIds(new Set()); // Сбросить modifiedIds
                modifiedRailChains.current = {};
                setFirstUpdateCopySource(false);
                if (searchInputRef.current) {
                  setSearch((prev) => prev);
                }
                navigate((url) => {
                  url.searchParams.delete('editing'); // Удалить параметр 'editing' из URL
                  return url;
                });
              }}
              isButton
            />
          </>
        )}
      </div>
      {/* Модальное окно */}
      <Modal
        width={confirmationOfChanges ? '100%' : '50%'}
        height={confirmationOfChanges ? '' : '60%'}
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        {confirmModal && (
          <>
            {confirmationOfChanges && (
              <>
                <CustomContainer>
                  <CustomTitle
                    titleText={
                      Object.keys(modifiedRailChains?.current || {}).length === 0
                        ? t?.noChangesToSave || 'Нет данных для изменения'
                        : t?.modifiedRailChainsTitle || 'Информация об измененных РЦ'
                    }
                  />

                  <div className="container-rail-chains-modify-table">
                    <ViewModifiedRailChains data={modifiedRailChains?.current} t={t} />
                    {viewBtnModifyTrack && (
                      <CustomButton
                        width="var(--sadr-font-size-280)"
                        className="confirmation-btn cancel"
                        color="var(--sadr-background-secondary)"
                        colorText="var(--sadr-border)"
                        margin="0 0 30px 0"
                        text={
                          showDisplayModifiedTrack
                            ? t?.hideTrackChanges || 'Скрыть изменения для трека'
                            : t?.showTrackChanges || 'Показать изменения для трека'
                        }
                        onClick={() => {
                          setShowDisplayModifiedTrack((prev) => !prev);
                        }}
                      />
                    )}
                    {showDisplayModifiedTrack && <DisplayModifiedTrack data={modifiedRailChains?.current} t={t} />}
                  </div>

                  <div className="margin-top-auto">
                    <h5 className="confirmation-title rail-chais-title">
                      {t?.confirmSaveChanges || 'Вы уверены, что хотите сохранить изменения?'}
                    </h5>
                    <div className="confirmation-btn-container">
                      <CustomButton
                        width="var(--sadr-font-size-280)"
                        className="confirmation-btn confirm"
                        text={t?.confirm || 'Подтвердить'}
                        onClick={onApply}
                        disabled={Object.keys(modifiedRailChains?.current || {}).length === 0}
                      />
                      <CustomButton
                        width="var(--sadr-font-size-280)"
                        className="confirmation-btn cancel"
                        color="var(--sadr-background-secondary)"
                        colorText="var(--sadr-border)"
                        text={t?.cancel || 'Отмена'}
                        onClick={() => {
                          setConfirmModal(false);
                          setIsOpen(false);
                          setShowDisplayModifiedTrack(false);
                        }}
                      />
                    </div>
                  </div>
                </CustomContainer>
              </>
            )}
            {loader?.isLoading && !confirmationOfChanges && (
              <>
                <div className="preloader-container">
                  <CustomTitle titleText={t?.savingInProgress || 'Идет процесс сохранения, пожалуйста подождите!'} />
                  <Preloader isLoading={loader?.isLoading} />
                </div>
              </>
            )}

            {!loader?.isLoading && !confirmationOfChanges && (
              <CustomContainer>
                <ConfirmationPage
                  onConfirm={() => {
                    setIsOpen(false);
                    setEditing(false);
                    setConfirmModal(false);
                    setConfirmText(t?.changesSaved || 'Изменения РЦ завершены');
                    modifiedRailChains.current = {};
                    setModifiedIds(new Set());
                    setFirstUpdateCopySource(false);
                  }}
                  confirmText={confirmText}
                  addNew={t?.close || 'Закрыть'}
                  btnWidth="var(--sadr-font-size-280)"
                />
              </CustomContainer>
            )}
          </>
        )}
      </Modal>
      <Routes>
        <Route
          path="/create/*"
          element={
            <Modal isOpen onClose={go2root} containerSelector=".infocard" minusSize="--sadr-font-size-40">
              <AddRailChains closeModal={go2root} t={t} />
            </Modal>
          }
        />
      </Routes>
    </div>
  );
}
